export function spaceNameToSpaceKey(name?: string | null): string | null {
	if (!name) return null;

	const words = name
		.split(' ')
		.map((word) => word.replace(/[^a-zA-Z0-9]+/g, ''))
		.filter((word) => word);

	if (!words) return null;

	let key;
	if (words.length > 1) {
		const initials = words.map((word) => word[0]);
		key = initials.join('').toUpperCase();
	} else {
		key = words[0];
	}

	if (!key) return null;

	return key.length > 10 ? key.substring(0, 10) : key;
}
